var productListItem = function(){
    var scope = ".js-product-list-item";

    ui.ready(
        scope,
        function($item){
            var $input = $item.find(scope+"__qty-input");
            var $moreButton = $item.find(scope+"__qty-more");
            var $lessButton = $item.find(scope+"__qty-less");

            $moreButton.click(
                function(ev){
                    ev.preventDefault();
                    var newQuantity = parseInt($input.text())+1;
                    shopCart.setProductQuantity($item.data("product-id"),newQuantity,function(data){
                        $input.text(data.quantity);
                        $item.data("cart-quantity",data.quantity);
                        $item.trigger("web:cartQuantityUpdate",data);
                    });
                }
            );

            $lessButton.click(
                function(ev){
                    ev.preventDefault();
                    if($input.text()>0){
                        var newQuantity = parseInt($input.text())-1;
                        shopCart.setProductQuantity($item.data("product-id"),newQuantity,function(data){
                            $input.text(data.quantity);
                            $item.data("cart-quantity",data.quantity);
                            $item.trigger("web:cartQuantityUpdate",data);
                        });
                    }
                }
            );


            $item.find(scope+"__buy").click(
                function(ev){
                    ev.preventDefault();
                    if($item.data("product-periodic-sale")==1){
                        var href = $item.find(scope+"__product-name-href").attr("href");
                        if(href){
                            window.location = href;
                        }
                    }else{
                        shopCart.setProductQuantity(
                            $item.data("product-id"),
                            $item.data("cart-quantity")+1,
                            function(data){
                                $item.data("cart-quantity",data.quantity);
                                $item.trigger("web:cartQuantityUpdate",data);
                            }
                        );
                    }
                }
            );
        }
    );

    ui.readyBody(
        function($body){
            $body.on(
                "web:cartQuantityUpdate",
                function(ev,data){
                    gvf.delay(
                        1000,
                        function(){
                            var $items = $(scope);
                            if(data.product_id){
                                $items = $items.filter("[data-product-id="+data.product_id+"]");
                            }
                            $items.each(
                                function(){
                                    $(this).data("cart-quantity",data.quantity?data.quantity:0);
                                }
                            );
                        }
                    );
                }
            );
        }
    );
}();